<template>
  <modal
    :is-opened="isOpened"
    :on-close="close"
    class="buyer-rdv"
  >
    <template #header>
      {{ trans('offer.match_rdv.title') }}
    </template>
    <template #body>
      <div class="buyer-rdv__main buyer-rdv-body">
        <p class="buyer-rdv-body__text">
          {{ trans('offer.match_rdv.text') }}
        </p>
        <div class="buyer-rdv-body__contact buyer-contact">
          <profile-picture
            :uuid="getContact.pic"
          />
          <span class="buyer-contact__name">{{ getContact.name }}</span>
          <span class="buyer-contact__job">{{ getContact.job }}</span>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="buyer-rdv__calendly">
        <a class="btn btn--primary" target="_blank" :href="getContact.calendly">{{ trans('offer.match_rdv.cta') }}</a>
        <p><a href="#" class="" @click="close">{{ trans('offer.match_rdv.call_me_whenever') }}</a></p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import ProfilePicture from '@components/ProfilePicture.vue';
import { translationMixin } from '@tools/translation';

/**
 * Init RDV Component
 * This component use the modal component as a child.
 */
export default {
  components: { ProfilePicture, Modal },
  mixins: [ translationMixin ],
  props: {
    isOpened: { type: Boolean, default: false },
  },
  computed: {
    getContact() {
      return window.initialAppState.first_contact_after_creation;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.buyer-rdv {
  &-body {
    &__text {
      @include fontBody;
      margin-bottom: toRem(8);
    }

    &__contact {
      @include profilePicture(96);
      margin: 0 auto;
      text-align: center;

      .image-profile {
        display: inline-block;
      }

      svg {
        height: toRem(96);
      }

      .buyer-contact__name,
      .buyer-contact__job {
        @include fontBody;
        display: block;
      }

      .buyer-contact__name {
        font-weight: bold;
        margin-bottom: toRem(4);
      }

      .buyer-contact__job {
        margin-bottom: toRem(16);
      }
    }
  }

  &__calendly {
    text-align: center;

    p {
      margin: toRem(16) 0 0;

      a {
        @include fontActionSmallLink;
        color: $colorBlue;
        text-decoration: underline;
      }
    }
  }
}

@media screen and (min-width: $breakMobile) {
  .buyer-rdv {
    &-body {
      &__contact {
        width: toRem(300);
      }
    }
  }
}
</style>
